module.exports = __webpack_public_path__ + "img/Eventos_ver_participantes_azul.f0efb4f9.svg";